import { datadogRum } from '@datadog/browser-rum';

const DD_APPLICATION_ID = process.env.REACT_APP_DD_APPLICATION_ID;
const DD_CLIENT_TOKEN = process.env.REACT_APP_DD_CLIENT_TOKEN;

export function initDatadog() {
    if (!DD_APPLICATION_ID || !DD_CLIENT_TOKEN) {
        return;
    }

    datadogRum.init({
        applicationId: DD_APPLICATION_ID,
        clientToken: DD_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        service: 'pwa-backoffice',
        env: process.env.REACT_APP_CONTEXT || 'dev',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
}

export function setDatadogUser({ username, userUniqueId, roles }) {
    if (!DD_APPLICATION_ID || !DD_CLIENT_TOKEN) {
        return;
    }

    const isInternal = roles?.includes('ROLE_M360');

    datadogRum.setUser({
        id: userUniqueId,
        name: username,
        role: isInternal ? 'internal' : 'external',
    });
}

export function clearDatadogUser() {
    if (!DD_APPLICATION_ID || !DD_CLIENT_TOKEN) {
        return;
    }

    datadogRum.clearUser();
}
